import axios from "axios";
import { toast, Zoom } from "react-toastify";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
const Msg = ({ buyer, IMEI, time }) => (
  <div>
    {" "}
    <p>
      <b>
        {" "}
        {buyer} <br /> {IMEI}{" "}
      </b>{" "}
      <br /> New sale has been added.{" "}
    </p>{" "}
  </div>
);

// ------------------Initial State------------------//
var initialState = {
  status: null,
  newMailValid: false,
  currentUser: {},
  currentUserIsAdmin: false,
  currentUserRegistration: false,
  currentUserIsLawyer: false,
  currentUserIsCustomer: false,
  currentUserIsActive: false,
  allUsers: [],
};
// allData
// ------------------All Asyn Reducers are below ------------------//

// ------------------All data Getter Setter Reducers ------------------//

// asyn New Actor Registration
export const newUserMaker = createAsyncThunk(
  "mainSlice/newUserMaker",
  async ({
    actorRole,
    actorFirstName,
    actorLastName,
    actorEmail,
    actorPassword,
    actorDP,
    actorPDF,
  }) => {
    const data = await axios.post("/newUser", {
      actorRole,
      actorFirstName,
      actorLastName,
      actorEmail,
      actorPassword,
      actorDP,
      actorPDF,
    });
    return data.data;
  }
);

// asyn Login
export const userLogin = createAsyncThunk(
  "mainSlice/userLogin",
  async ({ email, password }) => {
    const data = await axios.post("/login", {
      email,
      password,
    });
    return data.data;
  }
);
// asyn Login
export const allUsersGetter = createAsyncThunk(
  "mainSlice/allUsersGetter",
  async () => {
    const data = await axios.get("/allData"); 
    return data.data;
  }
);

// asyn setter
const mainSlice = createSlice({
  name: "mainSlice",
  initialState,
  reducers: {
    LOG_OUT: (state) => {
      state.currentUserIsActive = false;
      state.status = null;
      state.newMailValid = false;
      state.currentUser = {};
      state.currentUserIsAdmin = false;
      state.currentUserRegistration = false;
      state.currentUserIsLawyer = false;
      state.currentUserIsCustomer = false;
    },
  },
  extraReducers: {
    // ------------------Response Login ------------------//
    [userLogin.pending]: (state, action) => {
      state.status = "loading";
      Toast.fire({
        icon: "info",
        title: "Loading...",
      });
    },
    [userLogin.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        Toast.fire({
          icon: "success",
          title: "Logged In Successfully",
        });
        if (payload.message.actorRole === "lawyer") {
          state.currentUserIsLawyer = true;
          state.currentUserIsCustomer = false;
          state.currentUserIsActive = true;
          state.currentUser = payload.message;
        } else if (payload.message.actorRole === "customer") {
          state.currentUserIsLawyer = false;
          state.currentUserIsCustomer = true;
          state.currentUserIsActive = true;
          state.currentUser = payload.message;
        } else if (payload.message.actorRole === "admin") {
          state.currentUserIsAdmin = true;
          state.currentUserIsLawyer = false;
          state.currentUserIsCustomer = false;
          state.currentUserIsActive = true;
          state.currentUser = payload.message;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${payload.message}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${payload.message}`,
        });
      }
    },
    [userLogin.rejected]: (state, action) => {
      state.status = "failed";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Check Your Internet Connection!",
      });
    },

    // ------------------Response Registration ------------------//

    [newUserMaker.pending]: (state, action) => {
      state.status = "loading";
      Toast.fire({
        icon: "info",
        title: "Loading...",
      });
    },
    [newUserMaker.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        Toast.fire({
          icon: "success",
          title: "Registered Successfully !",
        });
        state.currentUserRegistration = true;
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${payload.message}`,
        });
      }
    },
    [newUserMaker.rejected]: (state, action) => {
      state.status = "failed";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Check Your Internet Connection!",
      });
    },

    // -------------allUsersGetter----------------//

    [allUsersGetter.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        state.allUsers = payload.message;
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${payload.message}`,
        });
      }
    },
    [allUsersGetter.rejected]: (state, action) => {
      state.status = "failed";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Check Your Internet Connection!",
      });
    },

    // end of all Extra Reducers reducers
  },
});

export const { LOG_OUT } = mainSlice.actions;

// ------------------All Asyn Getter Setter Reducers Exporter ------------------//

export const mainReducer = mainSlice.reducer;
